export default function() {
	$("#documents-filter").on('input', function(e) {
		e.preventDefault();

		const val = $(this).val().toLowerCase();

		$('#documents .card').map((k,v)=>{
			const check = (
				v.dataset.title.toLowerCase().includes(val) ||
				v.dataset.description.toLowerCase().includes(val) ||
				v.dataset.date.toLowerCase().includes(val));

			$(v).toggleClass('hidden', !check);
		});
	});
};
